import MessageClient from "./MessageClient";
import { IReaction } from "../../commons/interfaces";
import { Constants } from "../../constants/constants";


const ReactionService = {
    getAll: async (): Promise<IReaction[]> => {
        const result = await MessageClient().get(Constants.ApiPath.Reaction.GET_ALL);
        return result.data.result;
    },
};

export default ReactionService;
